import { render } from "./faq.vue?vue&type=template&id=44480666&scoped=true"
const script = {}

import "./faq.vue?vue&type=style&index=0&id=44480666&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44480666"]])

export default __exports__